import { useQuery } from "@tanstack/react-query";
import { clientAPI } from "../../api/client";
import { LimitDataSelect } from "../../utils/globalVariable";

async function fetchConstantData(searchTermCustomerType) {
  const searchOptions = {
    limit: LimitDataSelect || 10,
    page: 1,
  };

  if (searchTermCustomerType) {
    searchOptions.search = searchTermCustomerType;
  }
  const searchQueryParams = new URLSearchParams(searchOptions).toString();

  // Fetch constant data concurrently
  const [employee] = await Promise.all([
    clientAPI("get", `/employee?${searchQueryParams}`),
  ]);

  // Index data by 'id' to improve lookup performance
  return {
    employee: employee?.items?.reduce(
      (acc, item) => ({
        ...acc,
        [item._id]: {
          fullName: item.fullName,
          code: item.code,
        },
      }),
      {}
    ),
  };
}

export function useCategories(shouldFetch, searchTermCustomerType) {
  // Fetch constant data once
  const {
    data: constantData,
    isLoading,
    isFetching,
    refetch,
  } = useQuery({
    queryKey: ["share_customer", searchTermCustomerType],
    queryFn: () => fetchConstantData(searchTermCustomerType),
    enabled: shouldFetch,
    refetchOnWindowFocus: false,
  });

  return {
    constantData,
    isLoading,
    isFetching,
    refetch,
  };
}
